import {HttpErrorResponse,HttpResponse} from '@angular/common/http';
import {Component,OnDestroy,OnInit} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {IMyDateModel,IMyOptions} from 'mydatepicker';
import {JhiAlertService} from 'ng-jhipster';
import {BsModalRef,BsModalService} from 'ngx-bootstrap';
import {Observable} from 'rxjs';
import {Principal} from 'src/app/core/auth/principal.service';
import {ClauseExtensionMySuffixService} from 'src/app/entities/clause-extension-my-suffix/clause-extension-my-suffix.service';
import {CountryMySuffixService} from 'src/app/entities/country-my-suffix';
import {ConfirmationModalComponent} from 'src/app/shared/confirmation-modal/confirmation-modal.component';
import {ConfirmationModelService} from 'src/app/shared/confirmation-modal/confirmation-model.service';
import {InformationModelComponent} from 'src/app/shared/information-model/information-model.component';
import {InformationModelService} from 'src/app/shared/information-model/Information-model.service';
import {AddressMySuffix,IAddressMySuffix,State} from 'src/app/shared/model/address-my-suffix.model';
import {ICountryMySuffix} from 'src/app/shared/model/country-my-suffix.model';
import {IFileDataMySuffix} from 'src/app/shared/model/file-data-my-suffix.model';
import {FutureDataType} from 'src/app/shared/model/future_data_type.model';
import {InformationType} from 'src/app/shared/model/information_type.model';
import {InsuranceCompanySurveyAssociationPriority,ISurveyAssociationPriority} from 'src/app/shared/model/insurance-company-my-suffix.model';
import {IPolicyMySuffix} from 'src/app/shared/model/policy-my-suffix.model';
import {ISurveyAssociationMySuffix} from 'src/app/shared/model/survey-association-my-suffix.model';
import {IUnderwriterMySuffix} from 'src/app/shared/model/underwriter-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {InsuranceCompanyMySuffixService} from '../insurance-company-my-suffix';
import {UnderwriterMySuffixService} from './underwriter-my-suffix.service';
import { CommonUtils } from 'src/app/shared/util/common-utils';


declare var $: any;
@Component({
    selector: 'jhi-underwriter-my-suffix-update',
    templateUrl: './underwriter-my-suffix-update.component.html'
})
export class UnderwriterMySuffixUpdateComponent implements OnInit , OnDestroy{
    private _underwriter: IUnderwriterMySuffix;
    isSaving: boolean;
    numberPattern = '^(?=.*?[1-9])[0-9()-]+$';
    numberStringPattern = '^[A-Za-z0-9]+$';
    isInsurersCollapsed = true;
    signatures: IFileDataMySuffix[];

    countriesObj = [];

    telephoneCodeCountryObj = [];

    underwriteraddresses: IAddressMySuffix[];

    countries: ICountryMySuffix[];

    policies: IPolicyMySuffix[];

    licensedCountries: ICountryMySuffix[];

    licenseExcludedCountries: ICountryMySuffix[];

    fileMultiPartData: any;
    flag = false;
    underwriterIdOnCreate: any;

    isStateMandatory:boolean = false;
    stateObj: any;
    stateData: State[] = [];
    standardSurveyDisabled: boolean = false;

    countryDropdownSettings = {
        singleSelection: true,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        closeDropDownOnSelection: true,
        defaultOpen:false
    };

    stateDropdownSettings = {
        singleSelection: true,
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        closeDropDownOnSelection: true,
        defaultOpen:false
    };

    // effective date
    date: Date = new Date();
    resetDateModel = { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: (this.date.getDate() - 1) }
    effectivepDatePickerOptions: IMyOptions = {
        dateFormat: 'dd/mm/yyyy',
        disableUntil: this.resetDateModel
    };
    fromEffeciveDate: any;
    dateModel = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate()
    }
    surveyAssociationPriorities: ISurveyAssociationPriority[];
    surveyAssociationData: ISurveyAssociationMySuffix[];
    surveyAssociationOriginalData: ISurveyAssociationMySuffix[];
    surveyAssociationOriginalPriorities: ISurveyAssociationPriority[];
    allowAdd: boolean;
    surveyAssociationDataObj = [];
    surveyAssociationPriorityObj = [];
    surveyAssociationSettings = {
        singleSelection: true,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        closeDropDownOnSelection: true,
        defaultOpen:false
    };
    surveyAssociationPrioritySettings = {
        singleSelection: true,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        closeDropDownOnSelection: true,
        defaultOpen:false
    };
    constructor(
        private jhiAlertService: JhiAlertService,
        private underwriterService: UnderwriterMySuffixService,
        private countryService: CountryMySuffixService,
        private activatedRoute: ActivatedRoute,
        private clauseExtensionService: ClauseExtensionMySuffixService,
        private router: Router,
        private languageChangeService: LanguageChangeService,
        private principal: Principal,
        private modalService: BsModalService,
        private confirmationModelService: ConfirmationModelService,
        private insuranceCompanyService: InsuranceCompanyMySuffixService,
        private informationModelService: InformationModelService,
    ) {
                this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
     }

    ngOnInit() {
        this.effectivepDatePickerOptions.disableUntil = this.principal.dateFormateServerToClientMin(this.date);
        this.isSaving = false;

        this.underwriterService.checkStandardSurveyEnabled().subscribe(res => {
            this.standardSurveyDisabled = res.body.payload
        })
        
        this.activatedRoute.data.subscribe(({ underwriter }) => {
            this.underwriter = underwriter;
            // if (this._underwriter.id !== undefined) {
            if (!CommonUtils.isNil(this._underwriter.id)) {
                this.countriesObj.push(this.underwriter.address.countryDTO);


                if(this.underwriter.address.countryDTO.isoTwo == 'US'){
                    this.isStateMandatory = true;
                    this.getStatesByCountryId(this.underwriter.address.countryDTO.id,false);
                }else{
                    this.isStateMandatory = false; 
                    this.stateData = [];
                }

                this.telephoneCodeCountryObj.push(this.underwriter.primaryContactCountryCode);
            }
            if (!this.underwriter.address) {
                this.underwriter.address = new AddressMySuffix();
            }
            // if (this.underwriter.id !== undefined) {
            if (!CommonUtils.isNil(this.underwriter.id)) {
                this.telephoneCodeCountryObj.push(this.underwriter.primaryContactCountryCode);
                this.surveyAssociationDataObj = [];
                this.underwriter.surveyAssociationPriorityInfoDTO.map((item, index) => {
                    this.surveyAssociationDataObj[index] = new Array();
                    this.surveyAssociationPriorityObj[index] = new Array();
                    let obj = { id: item.priority, name: item.priority.toString() }
                    this.surveyAssociationDataObj[index].push(this.underwriter.surveyAssociationPriorityInfoDTO[index].surveyAssociationDTO)
                    this.surveyAssociationPriorityObj[index].push(obj);
                })
                if (this.underwriter.surveyAssociationPriorityInfoDTO.length == 0) {
                    this.underwriter.surveyAssociationPriorityInfoDTO.push(new InsuranceCompanySurveyAssociationPriority());
                }

            } else {
                this.underwriter.surveyAssociationPriorityInfoDTO.push(new InsuranceCompanySurveyAssociationPriority());
                this.allowAdd = true;
            }
        });




        this.insuranceCompanyService.getSurveyAssociations().subscribe((res: any) => {
            this.surveyAssociationData = res.body;
            this.surveyAssociationOriginalData = res.body;
            this.setData();
        });
        //   console.log(this.underwriter);
        /* this.fileDataService.query({ filter: 'underwriter-is-null' }).subscribe(
            (res: HttpResponse<IFileDataMySuffix[]>) => {
                if (!this.underwriter.signatureId) {
                    this.signatures = res.body;
                } else {
                    this.fileDataService.find(this.underwriter.signatureId).subscribe(
                        (subRes: HttpResponse<IFileDataMySuffix>) => {
                            this.signatures = [subRes.body].concat(res.body);
                        },
                        (subRes: HttpErrorResponse) => this.onError(subRes.message)
                    );
                }
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );
        this.addressService.query({ filter: 'underwriter-is-null' }).subscribe(
            (res: HttpResponse<IAddressMySuffix[]>) => {
                if (!this.underwriter.underwriterAddressId) {
                    this.underwriteraddresses = res.body;
                } else {
                    this.addressService.find(this.underwriter.underwriterAddressId).subscribe(
                        (subRes: HttpResponse<IAddressMySuffix>) => {
                            this.underwriteraddresses = [subRes.body].concat(res.body);
                        },
                        (subRes: HttpErrorResponse) => this.onError(subRes.message)
                    );
                }
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );
        this.underwriterService.licensedQuery().subscribe(
            (res: HttpResponse<any>) => {
                this.licensedCountries = res.body;
                console.log(this.countries);
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );

        this.underwriterService.licenseExcludedquery().subscribe(
            (res: HttpResponse<any>) => {
                this.licenseExcludedCountries = res.body;
                console.log(this.countries);
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );
 */
        this.countryService.query().subscribe(
            (res: HttpResponse<ICountryMySuffix[]>) => {
                this.countries = res.body;
                console.log(this.countries);
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );
        /*  this.policyService.query().subscribe(
            (res: HttpResponse<IPolicyMySuffix[]>) => {
                this.policies = res.body;
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        ); */


        this.fromEffeciveDate = { date: this.dateModel }
    }

    previousState() {
        window.history.back();
    }


    save() {
        let incDate = this.principal.dateFormateClientToServer(this.fromEffeciveDate.date);
        this.underwriter.fromEffectiveDate = incDate;
        this.underwriter.address.countryDTO = this.countriesObj[0];

        if(this.stateObj && this.stateObj.length>0){
            this.underwriter.address.state = this.stateObj[0];
        }else{
            this.underwriter.address.state = null;
        }
        this.openConfirmationModalForFutureRecordDeletion();
        // this.openInformationModel(this.underwriter);
    }

    saveOrUpdate() {
        // monogoDB file upload call for the fileId

        // flag is to check is file uploaded or not
        if (this.flag) {
            this.uploadFile(this.fileMultiPartData);
        } else {
            this.saveUnderwriter();
        }
    }

    saveUnderwriter() {
        if (this.underwriter.surveyAssociationPriorityInfoDTO.length > 1) {
            for (let i = 0; i < this.underwriter.surveyAssociationPriorityInfoDTO.length; i++) {
                let res = this.underwriter.surveyAssociationPriorityInfoDTO[i]
                if (res.priority == null || res.priority == undefined || res.surveyAssociationDTO == null || res.surveyAssociationDTO == undefined) {
                    this.jhiAlertService.error(' Please provide all data for Survey Associations')
                    return;
                }
            };
        } else {
            for (let i = 0; i < 1; i++) {
                let res = this.underwriter.surveyAssociationPriorityInfoDTO[i]
                if ((this.checkNullOfUndefined(res.priority) && !this.checkNullOfUndefined(res.surveyAssociationDTO)) || (!this.checkNullOfUndefined(res.priority) && this.checkNullOfUndefined(res.surveyAssociationDTO))) {
                    this.jhiAlertService.error(' Please provide all data for Survey Associations')
                    return;
                }
            };
        }
        this.isSaving = true;
        console.log(this.underwriter, '  underwriters');
        // if (this.underwriter.id !== undefined) {
        if (!CommonUtils.isNil(this.underwriter.id)) {
            this.subscribeToSaveResponse(this.underwriterService.update(this.underwriter));
        } else {
            this.subscribeToSaveResponse(this.underwriterService.create(this.underwriter));
        }
    }

    private subscribeToSaveResponse(result: Observable<HttpResponse<IUnderwriterMySuffix>>) {
        result.subscribe(
            (res: HttpResponse<IUnderwriterMySuffix>) => {
                this.underwriterIdOnCreate = res.body.id;
                this.onSaveSuccess();
            },
            (res: HttpErrorResponse) => this.onSaveError()
        );
    }

    private onSaveSuccess() {
        this.isSaving = false;
        this.deleteExistedFutureRecordDetails();
        if (this.underwriter.id) {
            this.router.navigate(['/data-management/underwriter', this.underwriter.id, 'view']);
        } else {
            this.router.navigate(['/data-management/underwriter', this.underwriterIdOnCreate, 'view']);
        }
    }

    private onSaveError() {
        this.isSaving = false;
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    trackFileDataById(index: number, item: IFileDataMySuffix) {
        return item.id;
    }

    trackAddressById(index: number, item: IAddressMySuffix) {
        return item.id;
    }

    trackCountryById(index: number, item: ICountryMySuffix) {
        return item.id;
    }

    trackPolicyById(index: number, item: IPolicyMySuffix) {
        return item.id;
    }

    onCountryItemDeSelect(event){
        this.stateObj = [];
        this.stateData = [];
    }

    onCountryItemSelect(event) {
        this.stateObj = [];
        this.stateData = [];
        this.underwriter.address.addressCountryId = event.id;
        this.getStatesByCountryId(event.id,true);
    }

    getSelected(selectedVals: Array<any>, option: any) {
        if (selectedVals) {
            for (let i = 0; i < selectedVals.length; i++) {
                if (option.id === selectedVals[i].id) {
                    return selectedVals[i];
                }
            }
        }
        return option;
    }
    get underwriter() {
        return this._underwriter;
    }

    set underwriter(underwriter: IUnderwriterMySuffix) {
        this._underwriter = underwriter;

        this.stateObj = [];

        if (this.underwriter && this.underwriter.address && this.underwriter.address.state && this.underwriter.address.state.id) {
            this.stateObj.push(this.underwriter.address.state);
        }
    }

    // init call
    uploadFileInitialMethod($event) {
        this.fileMultiPartData = $event.target.files[0];
        this.flag = true;
    }

    // file upload method
    uploadFile(data) {
        let formData = new FormData();
        formData.append('file', data);
        // console.log(response);
        // this._underwriter.fileDTO.fileId = 'fileId';
        // this._underwriter.fileDTO.name = 'name';
        // this._underwriter.fileDTO.contenttype = 'application/pdf';
        // this._underwriter.fileDTO.sizeInBytes = 83483764;
        // // after getting the fileId from mongoDB invoking the saveClauseExtension
        // this.flag = false;
        // this.save();
        this.clauseExtensionService.uploadFileService(formData).subscribe(response => {
            if (response.body.fileId) {
                console.log(response);
                this._underwriter.fileDTO.fileId = response.body.fileId;
                this._underwriter.fileDTO.name = response.body.name;
                this._underwriter.fileDTO.contenttype = response.body.contentType;
                this._underwriter.fileDTO.sizeInBytes = response.body.size;
                // after getting the fileId from mongoDB invoking the saveClauseExtension
                this.flag = false;
                this.save();
            }
        });
    }

    numberOnly(event) {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode == 46) {
            return true;
        } else if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        } else return true;
    }

    onCountrySelect(event) {

        for (let i = 0; i < this.countries.length; i++) {

            if (this.countries[i].id == event.id) {
                this.underwriter.primaryContactCountryCode = event;
                this.underwriter.primaryContactCountryCode.code = event.code;
                this.underwriter.pContactCountryCode = this.countries[i].code;
                break;
            }
        }
    }

    /* onCountrySelect(event) {
        this.countryService.find(event.id).subscribe(
            (res: HttpResponse<ICountryMySuffix>) => {
                this.underwriter.primaryContactCountryCode = event;
                this.underwriter.primaryContactCountryCode.code = event.code;
                this.underwriter.pContactCountryCode = res.body.code;
            },
            (subRes: HttpErrorResponse) => this.onError(subRes.message)
        );
    } */
    onCountryDeSelect(event) {
        this.underwriter.primaryContactCountryCode = null;
        this.underwriter.pContactCountryCode = null;
    }

    trimName($event) {
        if (this.underwriter.name) {
            this.underwriter.name = this.underwriter.name.trim();
        }
    }
    trim(event) {
        if (event.target.value) {
            event.target.value = event.target.value.replace(/\s\s+/g, ' ').trim();
        }
    }
    trimStreetAddress($event) {
        if (this.underwriter.address.streetAddress) {
            this.underwriter.address.streetAddress = this.underwriter.address.streetAddress.trim();
        }
    }

    trimCity($event) {
        if (this.underwriter.address.city) {
            this.underwriter.address.city = this.underwriter.address.city.trim();
        }
    }

    trimState($event) {
        if (this.underwriter.address.state) {
            this.underwriter.address.state.name = this.underwriter.address.state.name;
        }
    }

    trimPostalCode($event) {
        if (this.underwriter.address.postalCode) {
            this.underwriter.address.postalCode = this.underwriter.address.postalCode.trim();
        }
    }


    onDateChanged(event: IMyDateModel) {
        // if (this.underwriter.id !== null && this.underwriter.id !== undefined) {
        if (!CommonUtils.isNil(this.underwriter.id)) {
            let selectedFromEffectiveDate = this.principal.dateFormateClientToServer(event.date)
            console.log('onDateChanged(): ', selectedFromEffectiveDate);
            this.underwriterService.findByIdAndFromEffectiveDate(this.underwriter.id, selectedFromEffectiveDate).subscribe(response => {
                console.log(response);
                if (response.body != null && response.body['isSuccess']) {
                    this.underwriter = response.body['payLoad'];
                    // if (this.underwriter.id !== undefined) {
                    if (!CommonUtils.isNil(this.underwriter.id)) {
                        this.countriesObj = [];
                        this.telephoneCodeCountryObj = [];
                        this.countriesObj.push(this.underwriter.address.countryDTO);

                        this.countryService.find(this.underwriter.address.countryDTO.id).subscribe(res=>{
                            let body = res.body;
                            if(body['isoTwo'] == 'US'){
                                this.isStateMandatory = true;
                                if( this.underwriter.address.state &&this.underwriter.address.state.id){
                                    this.stateObj.push(this.underwriter.address.state);
                                   }
                                this.getStatesByCountryId(this.underwriter.address.countryDTO.id,false);
                            }else{
                                this.isStateMandatory = false; 
                                this.stateData = [];
                            }

                        },err=>{});

                        this.telephoneCodeCountryObj.push(this.underwriter.primaryContactCountryCode);
                        this.surveyAssociationDataObj = [];
                        this.surveyAssociationPriorityObj = [];
                        this.underwriter.surveyAssociationPriorityInfoDTO.map((item, index) => {
                            this.surveyAssociationDataObj[index] = new Array();
                            this.surveyAssociationPriorityObj[index] = new Array();
                            let obj = { id: item.priority, name: item.priority.toString() }
                            this.surveyAssociationDataObj[index].push(this.underwriter.surveyAssociationPriorityInfoDTO[index].surveyAssociationDTO)
                            this.surveyAssociationPriorityObj[index].push(obj);
                        })
                        if (this.underwriter.surveyAssociationPriorityInfoDTO.length == 0) {
                            this.underwriter.surveyAssociationPriorityInfoDTO = [];
                            this.underwriter.surveyAssociationPriorityInfoDTO.push(new InsuranceCompanySurveyAssociationPriority());
                        }
                    }
                    if (!this.underwriter.address) {
                        this.underwriter.address = new AddressMySuffix();
                    }
                }
            });
        }
    }

    // global modal open and close event
    bsModalRef: BsModalRef;
    isConfirmDeletion = false;
    /* this is how we open a Modal Component from another component */
    openConfirmationModalForFutureRecordDeletion() {
        this.isConfirmDeletion = false;
        // if (this.underwriter.id !== null && this.underwriter.id !== undefined) {
        if (!CommonUtils.isNil(this.underwriter.id)) {
            let form_data = {
                masterId: this.underwriter.id,
                futureDataType: FutureDataType.UNDERWRITER.valueOf(),
                fromEffectiveDateFormatted: this.underwriter.fromEffectiveDate
            }
            this.confirmationModelService.findFutureRecordExisted(form_data).subscribe(response => {
                const resBody = response.body;
                if (resBody.isSuccess) {
                    const initialState = {
                        title: 'Underwriter (' + this.underwriter.name + ')',
                        message: resBody.message,
                    };
                    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, { initialState, class: "modal-lg" });
                    this.bsModalRef.content.onClose.subscribe(result => {
                        if (result) {
                            this.isConfirmDeletion = true;
                            this.saveOrUpdate();
                        }
                    });
                } else {
                    this.saveOrUpdate();
                }
            });

        } else {
            this.saveOrUpdate();
        }
    }


    deleteExistedFutureRecordDetails() {
        if (this.isConfirmDeletion) {
            let form_data = {
                masterId: this.underwriter.id,
                futureDataType: FutureDataType.UNDERWRITER.valueOf(),
                fromEffectiveDateFormatted: this.underwriter.fromEffectiveDate
            }
            this.confirmationModelService.deleteExistedFutureRecord(form_data).subscribe(response => {
                console.log(response);
                this.isConfirmDeletion = false;
            });
        }
    }

    // global modal open and close event
    // bsModalRef: BsModalRef;

    openInformationModel(mainObject) {

        // if (mainObject.id !== null && mainObject.id !== undefined) {
        if (!CommonUtils.isNil(mainObject.id)) {
            let form_data = {
                masterId: mainObject.id,
                informationType: InformationType.UNDERWRITER.valueOf()
            }
            this.informationModelService.fetchExistedInformationDetailsByType(form_data).subscribe(response => {
                const resBody = response.body;
                if (resBody && resBody.length > 0) {
                    const initialState = {
                        isUpdateType: true,
                        mainList: resBody,
                    };
                    this.bsModalRef = this.modalService.show(InformationModelComponent, { initialState, class: "modal-lg" });
                    this.bsModalRef.content.onClose.subscribe(result => {
                        console.log(result);
                        if (result) {
                            this.openConfirmationModalForFutureRecordDeletion();
                        }
                    });
                } else {
                    this.openConfirmationModalForFutureRecordDeletion();
                }
            });
        }

    }


    // if the form invalid open survey association Panel
    saveClick(formValid) {
        if (formValid) {

        } else {
            this.isInsurersCollapsed = false;
        }
    }
    setData() {
        let tempArr = [];
        this.surveyAssociationOriginalData.map((item, index) => {
            let arr = { id: null, name: null };
            arr.id = index + 1;
            arr.name = (index + 1).toString();
            tempArr.push(arr);
            this.surveyAssociationOriginalPriorities = tempArr;
            this.surveyAssociationPriorities = tempArr
        })
        this.surveyAssociationOriginalPriorities = this.surveyAssociationOriginalPriorities.map(item => item);
        this.surveyAssociationPriorities = this.surveyAssociationPriorities.map(item => item);
    }

    checkSurveyAssociationAllowToAdd() {
        let allowAdd = false;
        for (let index = 0; index < this.underwriter.surveyAssociationPriorityInfoDTO.length; index++) {
            const element = this.underwriter.surveyAssociationPriorityInfoDTO[index];
            // if ((element.priority == undefined || element.priority == null) || (element.surveyAssociationDTO == undefined || element.surveyAssociationDTO == null)) {
            if (CommonUtils.isNil(element.priority) || CommonUtils.isNil(element.surveyAssociationDTO)) {
                allowAdd = true
            }
            if (allowAdd) {
                break;
            }
        }
        this.allowAdd = allowAdd;
    }

    onSurveyAssociationSelect(event, index, surveyAssociationDataObj, surveyAssociationPriorityObj) {

        // if ((surveyAssociationDataObj) && (surveyAssociationPriorityObj)) {
        //     this.allowAdd = false;
        // } else {
        //     this.allowAdd = true;
        // }

         this.underwriter.surveyAssociationPriorityInfoDTO[index].surveyAssociationDTO = this.surveyAssociationDataObj[index][0];

        for (let i = 0; i < this.surveyAssociationDataObj.length; i++) {
            if (index == i) {
                for (let j = 0; j < this.surveyAssociationDataObj.length; j++) {
                    // if (this.surveyAssociationDataObj[j] != null && this.surveyAssociationPriorityObj[j] != undefined) {           
                    if (!CommonUtils.isNil(this.surveyAssociationDataObj[j]) && !CommonUtils.isNil(this.surveyAssociationPriorityObj[j])) {           
                        if ((this.surveyAssociationDataObj[j][0] && this.surveyAssociationDataObj[j][0].id == event.id) && index != j) {
                                this.duplicateSurveyAssocianRemove(index);
                                break;
                            }
                        }
                    }
                break;
            }

            // if ((this.surveyAssociationDataObj[i][0] && this.surveyAssociationDataObj[i][0].id == event.id)) {
            //         this.duplicateSurveyAssocianRemove(index);
            //         break;
            //     }
        }
        this.checkSurveyAssociationAllowToAdd();

    }

        duplicateSurveyAssocianRemove(index: number) { 
            this.underwriter.surveyAssociationPriorityInfoDTO.splice(index, 1);
            this.surveyAssociationDataObj.splice(index, 1);
            this.surveyAssociationPriorityObj.splice(index, 1);
            this.checkSurveyAssociationAllowToAdd();
            this.onError('Survey Association Already Selected');
        }

    onSurveyAssociationDeSelect(event, index, surveyAssociationDataObj, surveyAssociationPriorityObj) {
        this.underwriter.surveyAssociationPriorityInfoDTO[index].surveyAssociationDTO = null;
        this.allowAdd = true;
        surveyAssociationDataObj.splice(index, 1);
        surveyAssociationDataObj = [];
    }

    onPrioritySelect(event, index, surveyAssociationDataObj, surveyAssociationPriorityObj) {

        // if ((surveyAssociationDataObj) && (surveyAssociationPriorityObj)) {
        //     this.allowAdd = false;
        // } else {
        //     this.allowAdd = true;
        // }

        this.underwriter.surveyAssociationPriorityInfoDTO[index].priority = event.id;
        for (let i = 0; i < this.surveyAssociationPriorityObj.length; i++) {
            if (index == i) {
                for (let j = 0; j < this.surveyAssociationPriorityObj.length; j++) {
                    // if (this.surveyAssociationPriorityObj[j] != null && this.surveyAssociationPriorityObj[j] != undefined) {                 
                    if (!CommonUtils.isNil(this.surveyAssociationPriorityObj[j])) {                 
                        if ((this.surveyAssociationPriorityObj[j][0] && this.surveyAssociationPriorityObj[j][0].id == event.id) && index != j) {
                            this.removePrioritySelectObj(index);
                            break;
                        }
                    }
                }
                break;
            }

            // if ((this.surveyAssociationPriorityObj[i][0] && this.surveyAssociationPriorityObj[i][0].id == event.id)) {
            //     this.removePrioritySelectObj(index);
            //     break;
            // }
        }
        this.checkSurveyAssociationAllowToAdd();

    }

    removePrioritySelectObj(index) {
        this.underwriter.surveyAssociationPriorityInfoDTO.splice(index, 1);
        this.surveyAssociationDataObj.splice(index, 1);
        this.surveyAssociationPriorityObj.splice(index, 1);
        this.checkSurveyAssociationAllowToAdd();
        this.onError('Priority Already Selected');
    }

    onPriorityDeSelect(event, index, surveyAssociationDataObj, surveyAssociationPriorityObj) {
        this.underwriter.surveyAssociationPriorityInfoDTO[index].priority = null;
        this.allowAdd = true;
        // this.surveyAssociationDataObj[index].splice(index, 1);
        surveyAssociationPriorityObj.splice(index, 1);
        surveyAssociationPriorityObj = [];
    }
    onDropdownClose1(event, index) {
        $(document)
            .find('#laguagesKnownid1')
            .find('.dropdown-list')
            .removeClass('showDropdown');
    }
    // addParticipatingInsurer
    addParticipatingInsurer() {
        this.allowAdd = true;
        let participatingInsurer = new InsuranceCompanySurveyAssociationPriority();
        console.log(this.underwriter.surveyAssociationPriorityInfoDTO.length);
        this.underwriter.surveyAssociationPriorityInfoDTO.push(participatingInsurer);
        console.log(this.underwriter.surveyAssociationPriorityInfoDTO.length);
    }
    // deleteParticipatingInsurer
    deleteParticipatingInsurer(index: number) {
        this.underwriter.surveyAssociationPriorityInfoDTO.splice(index, 1);
        this.surveyAssociationDataObj.splice(index, 1);
        this.surveyAssociationPriorityObj.splice(index, 1);

        this.surveyAssociationPriorityObj.map((item, index) => {
            if (this.surveyAssociationPriorityObj[index] === []) {
                this.allowAdd = true;
            } else {
                this.allowAdd = false;
            }

        })
    }

    trackBySurveyAssociation(index: number, item) {
        return index;
    }
    formSave(formValid) {
        if (!formValid) {
            this.isInsurersCollapsed = false
        }
    }
    trimField(event){
        if (event.target.value) {
            event.target.value = event.target.value.trim()
        }
    }
    // method for allow alphabets and space and DOT symbol
    customContactNameRegularExpression(event) {
        const charCode = event.which ? event.which : event.keyCode;
        let value = event.target.value;
        let findLengthOfDotSymbol = 0;
        if (value.length > 0) {
            let array = value.split('');
            findLengthOfDotSymbol = array.filter(l => l === '.').length;
            console.log(findLengthOfDotSymbol, "findLengthOfDotSymbol");
        }
        // for allow only one dot 
        if (charCode == 46 && findLengthOfDotSymbol > 0) {
            return false
        }

        if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8 || charCode == 32 || charCode == 46) {
            return true;
        }
        else {
            return false;
        }
    }
    stateMandatory(id){
        let flag = false;
        this.countries.map(date=>{

            if(date['isoTwo'] == 'US' && date.id==id){
                flag = true;
            return;
            }
        });
        this.isStateMandatory = flag;
    }
    getStatesByCountryId(id ,flag:boolean){

        this.countryService.getStatesByCountryId(id).subscribe(res=>{
            this.stateData =  res.body;
         });

         if(flag){
            this.stateMandatory(id);
         }
        
    }

    ngOnDestroy(): void {
        this.jhiAlertService.clear()
    }

    checkNullOfUndefined(data) {
        return data == null || data == undefined
    }
}
